import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import ImageWithBasePath from "../imageWithBasePath";
import "../../../style/icon/tabler-icons/webfont/tabler-icons.css";
import { setExpandMenu } from "../../data/redux/sidebarSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  resetAllMode,
  setDataLayout,
} from "../../data/redux/themeSettingSlice";
import usePreviousRoute from "./usePreviousRoute";
import { SidebarDataTest } from "../../data/json/sidebarMenu";

interface SubmenuItem {
  label: string;
  link: string;
  submenu: boolean;
  showSubRoute: boolean;
  icon: string;
  base: string;
  materialicons: string;
  submenuItems: SubmenuItem[];
  role?: string[]; // Role is optional
  count?: number;
}

interface SidebarItemType {
  label: string;
  link?: string;
  submenu?: boolean;
  submenuItems?: SidebarItemType[];
  role?: string[];
  icon?: string;
  dot?: boolean;
}

interface SidebarSection {
  tittle: string;
  icon: string;
  showAsTab: boolean;
  separateRoute: boolean;
  submenuItems: SubmenuItem[];
}

const Sidebar = () => {

//   const Location = useLocation();
// const language = useSelector((state: any) => state.auth.language);
// const sidebarData = SidebarDataTest(language);

// const userDetails = useSelector((state: any) => state.auth.userDetails);
// const roleIdentifier = useSelector(
//   (state: any) => state.auth.userDetails?.Role?.Role_Identifier
// );

// const [subOpen, setSubopen] = useState<any>("Dashboard");
// const [subsidebar, setSubsidebar] = useState("");
// const dispatch = useDispatch();
// const previousLocation = usePreviousRoute();

// const toggleSidebar = (title: any) => {
//   localStorage.setItem("menuOpened", title);
//   if (title === subOpen) {
//     setSubopen("");
//   } else {
//     setSubopen(title);
//   }
// };

// const toggleSubsidebar = (subitem: any) => {
//   if (subitem === subsidebar) {
//     setSubsidebar("");
//   } else {
//     setSubsidebar(subitem);
//   }
// };

// const handleLayoutChange = (layout: string) => {
//   dispatch(setDataLayout(layout));
// };

// const handleClick = (label: any, themeSetting: any, layout: any) => {
//   toggleSidebar(label);
//   if (themeSetting) {
//     handleLayoutChange(layout);
//   }
// };

// const getLayoutClass = (label: any) => {
//   switch (label) {
//     case "Default":
//       return "default_layout";
//     case "Mini":
//       return "mini_layout";
//     case "Box":
//       return "boxed_layout";
//     case "Dark":
//       return "dark_data_theme";
//     case "RTL":
//       return "rtl";
//     default:
//       return "";
//   }
// };

// useEffect(() => {
//   const layoutPages = [
//     "/layout-dark",
//     "/layout-rtl",
//     "/layout-mini",
//     "/layout-box",
//     "/layout-default",
//   ];

//   const isCurrentLayoutPage = layoutPages.some((path) =>
//     Location.pathname.includes(path)
//   );
//   const isPreviousLayoutPage =
//     previousLocation &&
//     layoutPages.some((path) => previousLocation.pathname.includes(path));
// }, [Location, previousLocation, dispatch]);

// // ✅ Highlight correct submenu & parent based on current route
// useEffect(() => {
//   let matchedParent: string | null = null;

//   sidebarData.forEach((menu: any) => {
//     if (menu.submenuItems && menu.submenuItems.length > 0) {
//       menu.submenuItems.forEach((sub: any) => {
//         if (sub.link === Location.pathname) {
//           matchedParent = menu.tittle;
//         }
//       });
//     }
//   });

//   if (matchedParent) {
//     setSubopen(matchedParent); // open parent
//   } else {
//     const currentMenu = localStorage.getItem("menuOpened") || "Dashboard";
//     setSubopen(currentMenu);
//   }
// }, [Location.pathname, sidebarData]);

// const onMouseEnter = () => {
//   dispatch(setExpandMenu(true));
// };
// const onMouseLeave = () => {
//   dispatch(setExpandMenu(false));
// };

const allApplcaitionCount = useSelector((state:any)=>state.auth.applicationCounts)                                                                                
  const Location = useLocation();
  const language = useSelector((state:any)=>state.auth.language);
  const sidebarData = SidebarDataTest(language,allApplcaitionCount);

  const userDetails = useSelector((state:any)=>state.auth.userDetails)
  const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
  //.log("roleee", roleIdentifier)


  const [subOpen, setSubopen] = useState<any>("Dashboard");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const handleLayoutChange = (layout: string) => {
    dispatch(setDataLayout(layout));
  };

  const handleClick = (label: any, themeSetting: any, layout: any) => {
    toggleSidebar(label);
    if (themeSetting) {
      handleLayoutChange(layout);
    }
  };

  const getLayoutClass = (label: any) => {
    switch (label) {
      case "Default":
        return "default_layout";
      case "Mini":
        return "mini_layout";
      case "Box":
        return "boxed_layout";
      case "Dark":
        return "dark_data_theme";
      case "RTL":
        return "rtl";
      default:
        return "";
    }
  };
  const location = useLocation();
  const dispatch = useDispatch();
  const previousLocation = usePreviousRoute();

  useEffect(() => {
    const layoutPages = [
      "/layout-dark",
      "/layout-rtl",
      "/layout-mini",
      "/layout-box",
      "/layout-default",
    ];

    const isCurrentLayoutPage = layoutPages.some((path) =>
      location.pathname.includes(path)
    );
    const isPreviousLayoutPage =
      previousLocation &&
      layoutPages.some((path) => previousLocation.pathname.includes(path));


  }, [location, previousLocation, dispatch]);

  useEffect(() => {
    const currentMenu = localStorage.getItem("menuOpened") || 'Dashboard'
    setSubopen(currentMenu);
    // Select all 'submenu' elements
    const submenus = document.querySelectorAll(".submenu");
    // Loop through each 'submenu'
    submenus.forEach((submenu) => {
      // Find all 'li' elements within the 'submenu'
      const listItems = submenu.querySelectorAll("li");
      submenu.classList.remove("active");
      // Check if any 'li' has the 'active' class
      listItems.forEach((item) => {
        if (item.classList.contains("active")) {
          // Add 'active' class to the 'submenu'
          submenu.classList.add("active");
          return;
        }
      });
    });
  }, [Location.pathname]);

  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
  };



  return (
    <>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
  <div className="sidebar-logo z-3 bg-white mb-2" >
  
    <div className="logo-container"  style={{ width: "60px", height: "60px" }} >
      <ImageWithBasePath src="assets/img/GAPMC.png" alt="Logo"  />
    </div>

    <Link to="routes.index" className="logo-small w-100 bg-white">
    <div className="logo-container"   style={{ width: "50px", height: "auto" }} >
      <ImageWithBasePath src="assets/img/GAPMC.png" alt="Logo" />
    </div>

    </Link>
    <Link to="routes.index" className="dark-logo w-100 bg-white">
    <div className="logo-container"   style={{ width: "50px", height: "auto" }} >
      <ImageWithBasePath src="assets/img/GAPMC.png" alt="Logo" />
    </div>
    </Link>
  </div>
  {/* <div className="modern-profile p-3 pb-0">
    <div className="text-center rounded bg-light p-3 mb-4 user-profile">
      <div className="avatar avatar-lg online mb-3">
        <ImageWithBasePath
          src="assets/img/profiles/avatar-02.jpg"
          alt="Img"
          className="img-fluid rounded-circle"
        />
      </div>
      <h6 className="fs-12 fw-normal mb-1">Adrian Herman</h6>
      <p className="fs-10">System Admin</p>
    </div>
    <div className="sidebar-nav mb-3">
      <ul
        className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
        role="tablist"
      >
        <li className="nav-item">
          <Link className="nav-link active border-0" to="#">Menu</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link border-0" to="#">Chats</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link border-0" to="#">Inbox</Link>
        </li>
      </ul>
    </div>
  </div> */}
  <div className="sidebar-header p-3 pb-0 pt-2">
    <div
      className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center"
    >
      <div className="avatar avatar-md onlin">
        <ImageWithBasePath
          src="assets/img/profiles/avatar-02.jpg"
          alt="Img"
          className="img-fluid rounded-circle"
        />
      </div>
   
    </div>
    <div className="input-group input-group-flat d-inline-flex mb-4">
      <span className="input-icon-addon">
        <i className="ti ti-search"></i>
      </span>
      <input type="text" className="form-control" placeholder="Search in HRMS" />
      <span className="input-group-text">
        <kbd>CTRL + / </kbd>
      </span>
    </div>
    {/* <div
      className="d-flex align-items-center justify-content-between menu-item mb-3"
    >
      <div className="me-3">
        <Link to="#" className="btn btn-menubar position-relative">
          <i className="ti ti-shopping-bag"></i>
          <span className="badge bg-success rounded-pill d-flex align-items-center justify-content-center header-badge"
            >5</span>
        </Link>
      </div>
      <div className="me-3">
        <Link to="#" className="btn btn-menubar">
          <i className="ti ti-layout-grid-remove"></i>
        </Link>
      </div>
      <div className="me-3">
        <Link to="#" className="btn btn-menubar position-relative">
          <i className="ti ti-brand-hipchat"></i>
          <span
            className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge"
            >5</span>
        </Link>
      </div>
      <div className="me-3 notification-item">
        <Link to="#" className="btn btn-menubar position-relative me-1">
          <i className="ti ti-bell"></i>
          <span className="notification-status-dot"></span>
        </Link>
      </div>
      <div className="me-0">
        <Link to="#" className="btn btn-menubar">
          <i className="ti ti-message"></i>
        </Link>
      </div>
    </div> */}
  </div>
        <Scrollbars>
          <div className="sidebar-inner slimscroll ">
            <div id="sidebar-menu" className="sidebar-menu mt-5 pt-4">
              <ul>
             
             {sidebarData?.map((mainLabel, index) => {
      // Filter submenu items based on user role
      const filteredSubmenuItems = (mainLabel?.submenuItems ?? []).filter((item: any) => 
        !item?.role || (Array.isArray(item.role) && item.role.includes(roleIdentifier))
      );

  //     const filteredSubmenuItems = Array.isArray(mainLabel?.submenuItems)
  // ? mainLabel.submenuItems.filter((item: SubmenuItem) =>
  //     !item.role || (Array.isArray(item.role) && item.role.includes(roleIdentifier))
  //   )
  // : [];

  // Skip rendering if no submenu items are available after filtering
  if (!filteredSubmenuItems.length) return null;

  return (
    <React.Fragment key={`main-${index}`}>
      <li className="">
        <span className="text-info fw-bold">{mainLabel?.tittle}</span>
      </li>
      <li>
        <ul>
          {filteredSubmenuItems.map((title: any, i: number) => {
            let link_array: any = [];

            // Ensure submenuItems are properly filtered
            const filteredLinks = (title?.submenuItems ?? []).filter((link: any) => 
              !link?.role || (Array.isArray(link.role) && link.role.includes(roleIdentifier))
            );

            filteredLinks?.forEach((link: any) => {
              link_array.push(link?.link);

              if (link?.submenu) {
                // Filter deeper submenuItems
                const filteredSubSubmenuItems = (link?.submenuItems ?? []).filter((item: any) =>
                  !item?.role || (Array.isArray(item.role) && item.role.includes(roleIdentifier))
                );

                filteredSubSubmenuItems?.forEach((item: any) => {
                  link_array.push(item?.link);
                });
              }
            });

            title.links = link_array;

            return (
              <li className="submenu fs-2" key={`title-${i}`}>
             <Link
  to={title?.submenu ? "#" : title?.link}
  onClick={() =>
    handleClick(
      title?.label,
      title?.themeSetting,
      getLayoutClass(title?.label)
    )
  }
  className={` ${
    title?.links?.includes(Location.pathname) ? "active" : ""
  } ${
    title?.submenuItems
      ?.map((link: any) => link?.link)
      .includes(Location.pathname) ||
    title?.link === Location.pathname
      ? "active"
      : ""
  }`}
>
  <i className={`ti ti-${title.icon}`}></i>
  
  <span className="d-flex align-items-center justify-content-between flex-grow-1">
    <span>{title?.label}</span>
    {title?.count != null && (
      <span className="badge rounded-pill bg-primary text-white ms-auto px-2 py-1" style={{ fontSize: '0.75rem' }}>
        {title?.count}
      </span>
    )}
  </span>

  {title?.dot && (
    <span className="badge badge-danger fs-5 fw-medium text-white p-1">
      Hot
    </span>
  )}
  <span className={title?.submenu ? "menu-arrow" : ""} />
</Link>

                {title?.submenu !== false && subOpen === title?.label && (
                  <ul style={{ display: subOpen === title?.label ? "block" : "none" }}>
                    {filteredLinks?.map((item: any, j: any) => {
                      // Ensure submenuItems are properly filtered
                      const filteredSubItems = (item?.submenuItems ?? []).filter((subItem: any) =>
                        !subItem?.role || (Array.isArray(subItem.role) && subItem.role.includes(roleIdentifier))
                      );

                      return (
                        <li
                          className={filteredSubItems.length ? "submenu submenu-two" : ""}
                          key={`item-${j}`}
                        >
                          <Link
                            to={item?.submenu ? "#" : item?.link}
                            className={`${
                              filteredSubItems
                                .map((link: any) => link?.link)
                                .includes(Location.pathname) ||
                              item?.link === Location.pathname
                                ? "active"
                                : ""
                            } ${subsidebar === item?.label ? "subdrop" : ""}`}
                            onClick={() => {
                              toggleSubsidebar(item?.label);
                            }}
                          >
                            {item?.label}
                            <span className={item?.submenu ? "menu-arrow" : ""} />
                          </Link>

                          {filteredSubItems.length > 0 && (
                            <ul style={{ display: subsidebar === item?.label ? "block" : "none" }}>
                              {filteredSubItems.map((items: any, k: any) => (
                                <li key={`submenu-item-${k}`}>
                                  <Link
                                    to={items?.submenu ? "#" : items?.link}
                                    className={`${
                                      subsidebar === items?.label
                                        ? "submenu-two subdrop"
                                        : "submenu-two"
                                    } ${
                                      items?.submenuItems
                                        ?.map((link: any) => link?.link)
                                        .includes(Location.pathname) ||
                                      items?.link === Location.pathname
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    {items?.label}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </li>
    </React.Fragment>
  );
})}


              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
